import { Input } from '@ordo/ui/input'
import { Textarea } from '@ordo/ui/textarea'

export interface ContactFormData {
  firstName: string
  lastName: string
  email: string
  phoneNumber: string
  organizationName: string
  ordoUserId: string
  timezone: string
  notes: string
}

export function ContactFormFields({
  data,
  onChange,
}: {
  data: ContactFormData
  onChange: (field: keyof ContactFormData, value: string) => void
}) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      <div className="space-y-1.5">
        <label htmlFor="firstName" className="text-sm font-medium text-muted-foreground">
          First Name
        </label>
        <Input id="firstName" value={data.firstName} onChange={(e) => onChange('firstName', e.target.value)} />
      </div>
      <div className="space-y-1.5">
        <label htmlFor="lastName" className="text-sm font-medium text-muted-foreground">
          Last Name
        </label>
        <Input id="lastName" value={data.lastName} onChange={(e) => onChange('lastName', e.target.value)} />
      </div>
      <div className="space-y-1.5">
        <label htmlFor="email" className="text-sm font-medium text-muted-foreground">
          Email
        </label>
        <Input id="email" type="email" value={data.email} onChange={(e) => onChange('email', e.target.value)} />
      </div>
      <div className="space-y-1.5">
        <label htmlFor="phoneNumber" className="text-sm font-medium text-muted-foreground">
          Phone
        </label>
        <Input
          id="phoneNumber"
          type="tel"
          pattern="[\d\s\-\(\)\+]*"
          placeholder="(555) 123-4567"
          value={data.phoneNumber}
          onChange={(e) => onChange('phoneNumber', e.target.value)}
        />
      </div>
      <div className="space-y-1.5">
        <label htmlFor="organizationName" className="text-sm font-medium text-muted-foreground">
          Organization
        </label>
        <Input
          id="organizationName"
          value={data.organizationName}
          onChange={(e) => onChange('organizationName', e.target.value)}
        />
      </div>
      <div className="space-y-1.5">
        <label htmlFor="ordoUserId" className="text-sm font-medium text-muted-foreground">
          Ordo ID
        </label>
        <Input id="ordoUserId" value={data.ordoUserId} onChange={(e) => onChange('ordoUserId', e.target.value)} />
      </div>
      <div className="space-y-1.5">
        <label htmlFor="timezone" className="text-sm font-medium text-muted-foreground">
          Timezone
        </label>
        <Input
          id="timezone"
          placeholder="America/New_York"
          value={data.timezone}
          onChange={(e) => onChange('timezone', e.target.value)}
        />
      </div>
      <div className="space-y-1.5 sm:col-span-2">
        <label htmlFor="notes" className="text-sm font-medium text-muted-foreground">
          Notes
        </label>
        <Textarea id="notes" value={data.notes} onChange={(e) => onChange('notes', e.target.value)} rows={3} />
      </div>
    </div>
  )
}
